export function card_height (class_name) {
    let height = 400;
    switch (class_name) {
        case 'panel':
            height = 475;
            break;
        case 'postcard':
            height = 555;
            break;
        case 'full':
            height = 555;
            break;
        case 'big_and_tall':
            height = 735;
    }
    return `${height}px`;
};

export function pluralize(label, count) {
  label = count === 1 ? label : `${label}s`;
  return `${count} ${label}`;
}

export function insertAfter(newNode, node) {
    node.parentNode.insertBefore(newNode, node.nextSibling);
}

export function insertBefore(newNode, node) {
    node.parentNode.insertBefore(newNode, node);
}

export function htmlFromString(string) {
    let div = document.createElement('div');
    div.innerHTML = string;
    return div.firstChild
}

export function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

export function popup_window (loc, width, height, resizable, scrollbars, toolbar, dependent, window_name, location_bar, status_bar, align) {
    let left_position = 1;
    let top_position = 1;

    if (align === "center") {
        left_position = (screen.width ? (screen.width - width) / 2 : 0);
        top_position = (screen.height ? (screen.height - height) / 2 : 0);
    } else if (align === "topright") {
        left_position = (screen.width ? screen.width - width : 0);
        top_position = 1;
    } else if (align === "topcenter") {
        left_position = (screen.width ? (screen.width - width) / 2 : 0);
        top_position = 1;
    }

    let align_value = `top=${top_position},left=${left_position}`;
    let win = eval("window.open(loc, '${window_name}','width=${width},height=${height},resizable=${resizable},scrollbars=" + scrollbars + ",toolbar=" + toolbar + ",dependent=" + dependent + ",screenX=1,screenY=1,${align_value},location=${location_bar},status=${status_bar}')");
    win.focus();
};

export function configure_selectboxes () {
    function toggle_unselected_style (target) {
        let _selectbox = $(target);
        if ((!_selectbox) || (_selectbox.val() === '') || (!_selectbox.val())) {
            $(_selectbox).addClass('unselected');
        } else {
            $(_selectbox).removeClass('unselected');
        }
    };

    let selectboxes = $('.select-holder select');
    selectboxes.each(function(index, selectbox) {
        toggle_unselected_style(selectbox);

        $(selectbox).change(function (e) {
            toggle_unselected_style(e.currentTarget);
        });
    });
};

/**
 * valid_email(email)
 *
 * - says whether the provided email address is valid or not, and if not,
 *   why
 * - returns an Object with three attributes:
 *   {
 *      is_valid: <boolean>,
 *      error_code: <string>
 *      error_message: <string>
 *   }
 *  - possible error codes (strings):
 *    - 'email_empty'
 *    - 'email_invalid'
 *    - 'email_too_long'
 *  - callers can use those error codes to provide their own,
 *    context-specific error messaging
 *
 **/
export function valid_email (email) {
    if (!Boolean(email)) {
        return {is_valid: false, error_code: 'email_empty', error_message: 'The email address is empty.'};
    }

    const email_invalid_message = 'The email address is invalid.';
    const ret_email_invalid = {is_valid: false, error_code: 'email_invalid', error_message: email_invalid_message};

    // W3C HTML5 Validation
    if (!/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i.test(email)) {
        return ret_email_invalid;
    }

    // can't start with a dash
    if (/^\-/i.test(email)) {
        return ret_email_invalid;
    }

    // require a tld
    if (email.split('@')[1].split('.').length < 2) {
        return ret_email_invalid;
    }

    if (email.length > 320) {
        return {is_valid: false, error_code: 'email_too_long', error_message: 'The email address too long. Max length is 320 characters.'};
    }

    return {is_valid: true, error_code: '', error_message: ''};
}

// specialized version of valid_email, above, for guest emails - returns
// a 2-element array of [<is_valid>, <error_message>]
export function guest_valid_email (email) {
    const email_invalid_messages = {
        email_empty: 'Please include an email for this guest.',
        email_invalid: 'Please provide a valid email address.',
        email_too_long: 'Email too long. Max length is 320 characters.',
        '': ''      // for when there's no error
    };
    const validity = valid_email(email);
    return [validity.is_valid, email_invalid_messages[validity.error_code]];
}


/**
 * parse_us_phone_number(phone_number_text)
 *
 * (also works for canadian phone numbers)
 *
 * - pulls out a 10-digit number sequence (string) from the text entered,
 *   if possible
 * - if an 11-digit sequence is found and the first is a 1 (old school
 *   for "long distance"), the first digit (1) is discarded
 * - returns an Object with three attributes:
 *   {
 *      is_valid: <boolean>,
 *      formatted: <string>
 *      digits: <string>
 *   }
 *
 * Examples:
 * - parse_us_phone_number('  310.123-4567 ') returns:
 *   {
 *      "is_valid": true,
 *      "formatted": "(310) 123-4567",
 *      "digits": "3101234567"
 *   }
 * - parse_us_phone_number('3456 tom ugh') returns:
 *   {
 *      "is_valid": false,
 *      "formatted": "",
 *      "digits": "3456"
 *   }
 *
 **/
export function parse_us_phone_number(phone_number_text) {
  let digits = _get_digits_from(phone_number_text);
  const is_standard_length = digits.length === 10;
  const is_1_prefixed_standard_length = digits.length === 11 && digits.charAt(0) === '1';
  if (! (is_standard_length || is_1_prefixed_standard_length)) {
    return {
      is_valid: false,
      formatted: '',
      digits
    };
  }
  if (is_1_prefixed_standard_length) {
      digits = digits.slice(1, 11);     // toss the leading 1
  }
  // TODO should this also make sure a 10-digit digit sequence is a valid
  // phone number, or is that overkill?
  return {
    is_valid: true,
    formatted: _format_to_us_phone_number(digits),
    digits
  }
}

export function normalize_phone_number(phone_number_string)
{
  // Returns the original string if it doesn't validate
  let parsed = parse_us_phone_number(phone_number_string);
  if (parsed.is_valid)
    return "+1" + parsed.digits;
  return phone_number_string;
}

// return just the digit characters from the given string
export function _get_digits_from(string_with_digits) {
  const allDigitChars = string_with_digits.match(/\d+/g) || [];
  return allDigitChars.join('');
}


export function pretty_format_phone_number(phone_digits_string) {
  // Returns a pretty formatted phone number, or the original if it is not a normalized phone number
  if (!phone_digits_string)
    return phone_digits_string;
  let digits = phone_digits_string.trim();
  if (digits[0] === '+')
    digits = digits.slice(1);
  if (digits[0] === '1' && digits.length === 11)
    digits = digits.slice(1);
  if (digits.match(/\D/) || digits.length !== 10)
    // Not a proper phone number, so return the original string
    return phone_digits_string;
  return _format_to_us_phone_number(digits);
}


// Ex: "3101234567" ==> "(310) 123-4567"
function _format_to_us_phone_number(digits) {
  return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + "-" + digits.slice(6, 10);
}


export function getURLParameter(name) {
  // mocks
  let search = window.mock_location_search || window.location.search;
  let matches = new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(search) || [null, ''];
  let data = decodeURIComponent(matches[1].replace(/\+/g, '%20'));
  if(data)
    return data;
  return null;
}


/**
 * stolen from the plugin jquery.parseParams
 *
 * @param query the url query (minus the ?)
 * @returns object of url parameters
 */
export function parseParams(query) {
  const re = /([^&=]+)=?([^&]*)/g;
  const decodeRE = /\+/g; // Regex for replacing addition symbol with a space
  const decode = function decode(str) {
    return decodeURIComponent(str.replace(decodeRE, " "));
  };

  let params = {}, e;
  while(e = re.exec(query)) {
    let k = decode(e[1]),
        v = decode(e[2]);
    if(k.substring(k.length - 2) === '[]') {
      k = k.substring(0, k.length - 2);
      (params[k] || (params[k] = [])).push(v);
    } else params[k] = v;
  }
  return params;
}

export function stringifyParams(params){
  let paramList = [];
  for(let key in params) {
    if (params.hasOwnProperty(key)) {
      let value = encodeURIComponent(params[key]);
      paramList.push(`${key}=${value}`);
    }
  }

  paramList.sort();

  return paramList.join('&');
}



// WEBPACK FOOTER //
// ./assets/es6/common/utils.es6